module.exports = __webpack_public_path__ + "assets/img/educator_register_with_roy.699ed393.png";